import React from "react";
import styled from "styled-components";
import Text, { TextType } from "./Text";
import { PrimaryColorPalette, StatusColorPalette } from "lib/styles/colors";
import InfoIcon from "lib/svgs/InfoIcon";

interface Props {
  message: string;
}

const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: ${StatusColorPalette.DANGER_TEXT};
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  margin-top: 0.3rem;
  width: 100%;
`;

export default function InputValidationError({ message }: Props) {
  return (
    <ErrorContainer>
      <InfoIcon width={12} height={12} color={PrimaryColorPalette.MAIN_6} />
      <Text
        type={TextType.ERROR_MESSAGE}
        fontColor={PrimaryColorPalette.MAIN_6}
        style={{ marginTop: "1px" }}
      >
        {message}
      </Text>
    </ErrorContainer>
  );
}
